import { render, staticRenderFns } from "./member.vue?vue&type=template&id=436652e3&scoped=true&"
import script from "./member.vue?vue&type=script&lang=ts&"
export * from "./member.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436652e3",
  null
  
)

export default component.exports